export default ($axios) => ({
  fetch(query) {
    return $axios.get('/admin/whitelabel', { params: query }).then((response) => response.data);
  },
  update(input) {
    return $axios.put('/admin/whitelabel', input);
  },
});
